export const PRIME_PREFIX_API = 'prime';

export const PRIME_PLACEMENT_LOCALSTORAGE = 'primePlacementSelected';
export const PRIME_LOCAL_STORAGE = 'primePackageSelected';

export const URL_PREVIEW_PACKAGE_SUGGESTION =
  'https://help.mamikos.com/post/bagaimana-tampilan-iklan-saya-di-mamiprime-halaman-pencarian-kos';
export const URL_PREVIEW_PACKAGE_SRP =
  'https://help.mamikos.com/post/bagaimana-tampilan-iklan-saya-di-mamiprime-halaman-hasil-pencarian';
